import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { Dismiss20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/Dismiss20Regular";

export function useMenuItem_SelectedFileCount(selectedItemCount: number, waitFor: boolean, setSelectionCleared: (selectionCleared: boolean) => void) {
  const languageStrings = React.useContext(LanguageContext);

  const menuItem_SelectedFileCount = React.useMemo(() => {
    if (selectedItemCount > 0 && !waitFor) {
      return {
        key: "selectedFileCount",
        text: `${selectedItemCount} ${languageStrings.Selected.toLowerCase()}`,
        disabled: waitFor === true,
        // iconProps: { iconName: "Clear" },
        iconProps: {},
        onRenderIcon: () => <Dismiss20Regular className={menuItemIconStyles} />,
        onClick: () => {
          setSelectionCleared(true)
        }
      } as IContextualMenuItem;
    }
    return null;
  }, [selectedItemCount, waitFor]);

  return {
    menuItem_SelectedFileCount
  }
}